<sc-padding>
  <form [formGroup]="formGroup" class="no-field-space">
    <sc-flex vertical stretchContent >
      <sc-flex-fitting-content vertical>
      <sc-string-field [required]="true" formControlName="recipients" labelDictionaryKey="tmc-yard.entity.filter-mail-schedule.recipients"></sc-string-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-radio-group aria-label="Format" formControlName="exportType">
        Format
        <mat-radio-button value="XLS">XLS</mat-radio-button>
        <mat-radio-button class="margin-left" value="CSV">CSV</mat-radio-button>
      </mat-radio-group>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-checkbox formControlName="periodic">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.filter-mail-schedule.periodic"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-number-field formControlName="periodicInterval" labelDictionaryKey="tmc-yard.entity.filter-mail-schedule.periodicInterval"></sc-number-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-time-field formControlName="timeOfDay" [required]="!filterMailSchedule.periodic" [disabled]="filterMailSchedule.periodic"
        [label]="'time of day' | translate: ['tmc-yard.entity.filter-mail-schedule.time-of-day', translationService.language, translationService.revision]"></sc-time-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-checkbox formControlName="monday" [disabled]="filterMailSchedule.periodic">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.filter-mail-schedule.monday"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-checkbox formControlName="tuesday" [disabled]="filterMailSchedule.periodic">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.filter-mail-schedule.tuesday"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-checkbox formControlName="wednesday" [disabled]="filterMailSchedule.periodic">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.filter-mail-schedule.wednesday"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-checkbox formControlName="thursday" [disabled]="filterMailSchedule.periodic">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.filter-mail-schedule.thursday"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-checkbox formControlName="friday" [disabled]="filterMailSchedule.periodic">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.filter-mail-schedule.friday"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-checkbox formControlName="saturday" [disabled]="filterMailSchedule.periodic">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.filter-mail-schedule.saturday"></sc-dictionary-label>
      </mat-checkbox>
      <sc-content-spacer vertical></sc-content-spacer>
      <mat-checkbox formControlName="sunday" [disabled]="filterMailSchedule.periodic">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.filter-mail-schedule.sunday"></sc-dictionary-label>
      </mat-checkbox>
    </sc-flex-fitting-content>
    </sc-flex>
  </form>
</sc-padding>
